import { createAsyncThunk } from '@reduxjs/toolkit'

import { $axios } from '@/shared/api/axios'
import { ServerResponse } from '@/shared/types/common'

import { FeatureFlags } from '../../types/featureFlags'

export const getFeatureFlagsConfig = createAsyncThunk('app/features-flags-config', async (_, thunkApi) => {
	try {
		const { data } = await $axios.get<ServerResponse<FeatureFlags>>('settings')

		return data.data
	} catch {
		return thunkApi.rejectWithValue('')
	}
})
